export default __webpack_public_path__ + "static/media/mano.71d837ea.jpg";